import React from "react";
import { useTranslation } from "react-i18next";
const FirstBallColorTable = ({ winningPlanArray }) => {
  const { t } = useTranslation();
  const getOddByBetType = (a, b, c) => {
    let x;
    c.map((item) => {
      if (item.BetType === a && item.Specifier === b) x = item.Value;
      return item;
    });
    return x;
  };
  return (
    <div className="luckysix-container">
      {t("betContent.firstBallColorBet.colorFirstBall")}
      <div className="pay-table-label-dark pay-table-line">
        {t("betContent.firstBallColorBet.pickUp4Colors")}
      </div>
      <div className="pay-table-label-dark-smaller">
        {t("betContent.firstBallColorBet.pickOneColor")} - 7.2 x{" "}
        {t("stakeUPER")}
      </div>
      <div className="pay-table-label-dark-smaller">
        {t("betContent.firstBallColorBet.pickTwoColors")} - 3.6 x{" "}
        {t("stakeUPER")}
      </div>

      <div className="pay-table-label-dark-smaller">
        {t("betContent.firstBallColorBet.pickFourColors")} - 1.8 x{" "}
        {t("stakeUPER")}
      </div>
    </div>
  );
};

export default FirstBallColorTable;
